import React from "react";
import {
  Box,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import translate from "i18n/translate";
import { SrCurrency } from "components/common";
import { transactionType } from "./constants";

const CardTransactions = ({ transactions, loading }) => {
  if (loading) {
    return <CircularProgress />;
  }

  return transactions?.length ? (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              {translate("srPagoCard.transactions.date")}
            </TableCell>
            <TableCell align="center">
              {translate("srPagoCard.transactions.deposits")}
            </TableCell>
            <TableCell align="center">
              {translate("srPagoCard.transactions.withdrawals")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transactions.map((row) => (
            <TableRow key={row.date + row.amount + Math.random()}>
              <TableCell align="center">{row.date}</TableCell>
              <TableCell align="center">
                {row.type === transactionType.DEPOSIT ? (
                  <SrCurrency value={row.amount} />
                ) : (
                  "-"
                )}
              </TableCell>
              <TableCell align="center">
                {row.type !== transactionType.DEPOSIT ? (
                  <SrCurrency value={row.amount} />
                ) : (
                  "-"
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Grid container justifyContent="center" spacing={2}>
      <Box padding={4} paddingTop={0}>
        <Typography variant="h3">
          {translate("resume.noTansactionsToShow")}
        </Typography>
      </Box>
    </Grid>
  );
};

export default CardTransactions;
